import playFilledAlt from '@iconify/icons-carbon/play-filled-alt';
import logoFacebook from '@iconify/icons-carbon/logo-facebook';
import logoTwitter from '@iconify/icons-carbon/logo-twitter';
import logoLinkedin from '@iconify/icons-carbon/logo-linkedin';
import logoYoutube from '@iconify/icons-carbon/logo-youtube';
import logoInstagram from '@iconify/icons-carbon/logo-instagram';
import close from '@iconify/icons-mdi/close';
import calender from '@iconify/icons-mdi/calendar';
import time from '@iconify/icons-carbon/time';
import arrowLeft from '@iconify/icons-carbon/arrow-left';
import arrowRight from '@iconify/icons-carbon/arrow-right';
import user from '@iconify/icons-mdi/perm-identity';
import menu from '@iconify/icons-mdi/menu';
import keyboardArrowUp from '@iconify/icons-mdi/keyboard-arrow-up';
import star from '@iconify/icons-mdi/star';
import starHalf from '@iconify/icons-mdi/star-half';
import whatsapp from '@iconify/icons-mdi/whatsapp';

const icons = {
	play: playFilledAlt,
	facebook: logoFacebook,
	twitter: logoTwitter,
	whatsapp: whatsapp,
	linkedin: logoLinkedin,
	youtube: logoYoutube,
	instagram: logoInstagram,
	close: close,
	calender: calender,
	time: time,
	arrowLeft: arrowLeft,
	arrowRight: arrowRight,
	user: user,
	menu: menu,
	keyboardArrowUp: keyboardArrowUp,
	star: star,
	starHalf: starHalf,
};

export default class ClearcalsIcons {
	public static all = icons;

	public static getIcon(iconName): any {
		if (icons[iconName]) {
			return icons[iconName];
		}

		return false;
	}
}
